import { FC } from "react";
import { AlertCircle, MoreVertical, Paperclip, X } from "react-feather";
import { useTranslation } from "react-i18next";
import { classic } from "../../../styled/colors";
import { Button } from "../../Common/Button";
import { Progress } from "../../Common/Progress";
import { StyledErrorMessage, StyledMedia, StyledMediaBody } from "./style";

interface IProps {
  title: string;
  link?: string;
  files: number;
  size: string;
  progress?: number;
  error?: string;
  isInternalUser?: boolean;
  onDelete?: () => any;
  onAttachmentClick?: () => any;
  onMoreClick?: () => any;
}

const Attachment: FC<IProps> = ({
  title,
  link,
  files,
  size,
  progress,
  error,
  isInternalUser,
  onDelete,
  onAttachmentClick,
  onMoreClick,
}) => {
  const { t } = useTranslation();
  const isSaving = !error && progress === 99;

  return (
    <StyledMedia>
      {error ? <AlertCircle color={classic.danger} /> : <Paperclip />}
      <StyledMediaBody>
        <h6 onClick={onAttachmentClick}>{title}</h6>
        {error && <StyledErrorMessage>{error}</StyledErrorMessage>}
        {/* <span>
          {files} files, {size}
        </span> */}
        {isSaving && (
          <span>{t("components.sharepoint.savingAttachment")}</span>
        )}
        {!error && !!progress && progress < 99 && (
          <Progress height="5px" now={progress} />
        )}
      </StyledMediaBody>
      {(!!error || !progress || progress === 100) && onDelete && (
        <Button color="info" variant="texted" label="Delete" onClick={onDelete}>
          <X size={16} />
        </Button>
      )}
      {!onDelete && onMoreClick && (
        <Button color="info" variant="texted" label="Delete" onClick={onDelete}>
          <MoreVertical size={16} onClick={onMoreClick} />
        </Button>
      )}
    </StyledMedia>
  );
};

export default Attachment;
